export default __webpack_public_path__ + "static/media/b1.cdf7f93b.jpg";